import { createPluginFactory } from "@udecode/plate";

export const createCopyPastePlugin = createPluginFactory({
  key: "copy-paste",
});
